var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_has.js
// module id = 14
// module chunks = 0